<script setup lang="ts">
const emit = defineEmits([
  'open-project',
  'open-about',
  'open-events',
  'open-how-it-works',
  'toggle-add-place',
  'close-all',
])
</script>

<template>
  <nav class="navbar">
    <div class="logo">
      <a href="#" @click.prevent="emit('close-all')">Poetická mapa Prahy</a>
    </div>

    <div class="nav-right">
      <ul class="nav-links">
        <li><a href="#" @click.prevent="emit('open-project')">O projektu</a></li>
        <!-- <li><a href="#" @click.prevent="emit('open-about')">O nás</a></li> -->
        <li><a href="#" @click.prevent="emit('open-events')">Události</a></li>
      </ul>

      <!-- Grouped the CTA and the question mark together -->
      <div class="action-group">
        <button class="cta-button" @click="emit('toggle-add-place')">
          Přidejte Poetické místo
        </button>

        <button
          class="subtle-question-btn"
          @click="emit('open-how-it-works')"
          title="Jak to funguje?"
        >
          ?
        </button>
      </div>
    </div>
  </nav>
</template>

<style scoped>
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;

  display: flex;
  justify-content: space-between;
  align-items: center;

  background-color: #fdfbf7;

  height: clamp(40px, 4.5vw, 50px);
  padding: 0 clamp(1.5rem, 3vw, 2rem);
  box-sizing: border-box;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.logo a {
  font-family: 'Newsreader', serif;
  font-weight: 700;
  font-size: clamp(1rem, 1.5vw, 1.25rem);
  color: #000000;
  text-decoration: none;
}

.logo a:hover {
  text-decoration: underline;
  text-underline-offset: 2px;
}

.nav-right {
  display: flex;
  align-items: center;
  gap: clamp(1rem, 2vw, 1.75rem);
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  gap: clamp(0.8rem, 1.5vw, 1.4rem);
  margin: 0;
  padding: 0;
}

.nav-links a {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: clamp(0.75rem, 1vw, 0.9rem);
  color: #000000;
  text-decoration: none;
}

.nav-links a:hover {
  text-decoration: underline;
  text-underline-offset: 4px;
  text-decoration-color: #000000;
}

/* New wrapper to keep the CTA and question mark close together */
.action-group {
  display: flex;
  align-items: center;
  gap: 10px; /* Keeps the ? button snug against the CTA */
}

.subtle-question-btn {
  display: flex;
  align-items: center;
  justify-content: center;

  /* Increased size and added clamp to scale with the CTA button */
  width: clamp(32px, 3.5vw, 36px);
  height: clamp(32px, 3.5vw, 36px);

  /* Added the slight black border */
  border: 1px solid #000000;
  background: transparent;
  color: #000000;

  font-family: 'Inter', sans-serif;
  font-weight: 600;

  /* Bumped font size up slightly to match the larger circle */
  font-size: clamp(1rem, 1.2vw, 1.1rem);
  cursor: pointer;
  border-radius: 50%;

  /* Changed transition to 'all' so the border color animates smoothly too */
  transition: all 0.2s ease;
  padding: 0;
}

.subtle-question-btn:hover {
  /* Pantone 130 orange */
  background-color: #f2a900;
  border-color: #f2a900;
  color: white;
}

.cta-button {
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: clamp(0.75rem, 1vw, 0.9rem);
  color: white;

  position: relative;
  z-index: 1;
  overflow: hidden;

  background: linear-gradient(90deg, #f2a900 0%, #e16400 100%);

  padding: clamp(0.4rem, 0.6vw, 0.6rem) clamp(0.8rem, 1.2vw, 1.2rem);
  border: none;
  border-radius: 2px;
  cursor: pointer;
}

.cta-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f2a900;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.cta-button:hover::before {
  opacity: 1;
}
</style>
